if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
	  this.isSubmitting = false;
	  this.isCardQuickAdd = Boolean(this.closest('.afs-card-overlay-slot, .afs-suggested-card__form'));
	  if (this.closest('.afs-card-overlay-slot')) {
		this.submitButton.addEventListener('click', (event) => event.stopPropagation());
	  }
      this.statusMessage = this.querySelector('[data-product-form-status]');
      this.successMessage = this.dataset.successMessage || 'Added to cart';
      this.networkErrorMessage = this.dataset.errorMessage || 'Something went wrong. Please try again.';
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.isSubmitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      window.clearTimeout(this.successTimer);
      this.submitButton.classList.remove('afs-quick-add--success');

      if (this.closest('.afs-suggested-card__form') && !this.form.checkValidity()) {
        const invalidControl = this.form.querySelector(':invalid');
        this.handleErrorMessage(invalidControl?.validationMessage || 'Enter a valid quantity.');
        invalidControl?.reportValidity();
        return;
      }

      this.isSubmitting = true;
      this.submitStartedAt = performance.now();

      this.handleErrorMessage();

      if (this.isCardQuickAdd) {
        const quantity = Number.parseInt(new FormData(this.form).get('quantity'), 10) || 1;
        this.optimisticCartSnapshot = this.incrementCartCount(quantity);
        this.dataset.badgeFeedbackMs = Math.round(performance.now() - this.submitStartedAt);
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.disabled = true;
      if (!this.isCardQuickAdd) {
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.isCardQuickAdd) {
        formData.append('sections', 'cart-icon-bubble,cart-drawer');
        formData.append('sections_url', window.location.pathname);
      } else if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (this.isCardQuickAdd) this.restoreCartCount();
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.isCardQuickAdd) {
            this.error = false;
            this.updateCartCount(response.sections?.['cart-icon-bubble']);
            this.updateCartDrawer(response.sections?.['cart-drawer']);
            if (this.statusMessage) this.statusMessage.textContent = this.successMessage;
            this.submitButton.classList.add('afs-quick-add--success');
            this.launchConfetti();
            this.dataset.successFeedbackMs = Math.round(performance.now() - this.submitStartedAt);
            this.successTimer = window.setTimeout(() => this.submitButton.classList.remove('afs-quick-add--success'), 1400);
            return;
          } else if (!this.cart) {
            // Card quick-add must never become product/cart-page navigation. The
            // normal theme renders a cart drawer/notification; this scoped fallback
            // still announces success if that host is unavailable or late-loading.
            if (this.closest('.afs-card-overlay-slot, .afs-suggested-card__form')) {
              this.error = false;
              if (this.statusMessage) this.statusMessage.textContent = this.successMessage;
              this.launchConfetti();
              return;
            }
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if (this.statusMessage) this.statusMessage.textContent = this.successMessage;
          this.launchConfetti();
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          if (this.isCardQuickAdd) this.restoreCartCount();
          this.submitButton.classList.remove('afs-quick-add--success');
          this.handleErrorMessage(this.networkErrorMessage);
        })
        .finally(() => {
          this.isSubmitting = false;
          if (!this.isCardQuickAdd) this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.disabled = false;
          }
          if (!this.isCardQuickAdd) this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    launchConfetti() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const rect = this.submitButton.getBoundingClientRect();
      const originX = Math.min(window.innerWidth - 18, Math.max(18, rect.left + rect.width / 2));
      const originY = Math.min(window.innerHeight - 18, Math.max(18, rect.top + rect.height / 2));
      const layer = document.createElement('span');
      layer.setAttribute('aria-hidden', 'true');
      layer.style.cssText = 'position:fixed;inset:0;z-index:2147483000;pointer-events:none;overflow:hidden;contain:strict;';

      const colors = ['#1e2a52', '#f4b942', '#e76f51', '#4f86c6'];
      const particles = 10;
      for (let index = 0; index < particles; index += 1) {
        const particle = document.createElement('i');
        const angle = (-150 + (120 / (particles - 1)) * index) * (Math.PI / 180);
        const distance = 34 + (index % 3) * 10;
        const x = Math.cos(angle) * distance;
        const y = Math.sin(angle) * distance + 22;
        particle.style.cssText = `position:absolute;left:${originX}px;top:${originY}px;width:5px;height:8px;border-radius:1px;background:${colors[index % colors.length]};transform:translate(-50%,-50%);`;
        layer.append(particle);
        particle.animate([
          { transform: 'translate(-50%,-50%) scale(1) rotate(0deg)', opacity: 1 },
          { transform: `translate(calc(-50% + ${x}px),calc(-50% + ${y}px)) scale(.75) rotate(${120 + index * 24}deg)`, opacity: 0 }
        ], { duration: 560 + (index % 3) * 55, easing: 'cubic-bezier(.18,.7,.25,1)', fill: 'forwards' });
      }

      document.body.append(layer);
      window.setTimeout(() => layer.remove(), 760);
    }

    updateCartCount(sectionHtml) {
      if (!sectionHtml) return;

      const currentCartLink = document.querySelector('#cart-icon-bubble');
      if (!currentCartLink) return;

      const nextBubble = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('.cart-count-bubble');
      const currentBubble = currentCartLink.querySelector('.cart-count-bubble');
      if (nextBubble && currentBubble) {
        currentBubble.replaceWith(nextBubble);
      } else if (nextBubble) {
        currentCartLink.append(nextBubble);
      } else {
        currentBubble?.remove();
      }
      this.optimisticCartSnapshot = null;
    }

    updateCartDrawer(sectionHtml) {
      if (!sectionHtml || !this.cart?.matches('cart-drawer')) return;

      const nextDrawer = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('#CartDrawer');
      const currentDrawer = this.cart.querySelector('#CartDrawer');
      if (!nextDrawer || !currentDrawer) return;

      currentDrawer.innerHTML = nextDrawer.innerHTML;
      this.cart.classList.remove('is-empty');
      this.cart.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.cart.close.bind(this.cart));
    }

    incrementCartCount(quantity) {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return null;

      const currentBubble = cartLink.querySelector('.cart-count-bubble');
      const snapshot = currentBubble ? currentBubble.outerHTML : '';
      const currentCount = Number.parseInt(currentBubble?.querySelector('[aria-hidden="true"]')?.textContent, 10) || 0;
      const nextCount = currentCount + quantity;
      const bubble = currentBubble || document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `<span aria-hidden="true">${nextCount}</span><span class="visually-hidden">${nextCount} items</span>`;
      if (!currentBubble) cartLink.append(bubble);
      return {cartLink, snapshot};
    }

    restoreCartCount() {
      if (!this.optimisticCartSnapshot) return;

      const {cartLink, snapshot} = this.optimisticCartSnapshot;
      const currentBubble = cartLink.querySelector('.cart-count-bubble');
      if (snapshot) {
        const previousBubble = new DOMParser().parseFromString(snapshot, 'text/html').querySelector('.cart-count-bubble');
        if (previousBubble && currentBubble) currentBubble.replaceWith(previousBubble);
      } else {
        currentBubble?.remove();
      }
      this.optimisticCartSnapshot = null;
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (this.statusMessage) this.statusMessage.textContent = '';

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        if (this.statusMessage && this.errorMessageWrapper.getAttribute('role') !== 'alert') {
          this.statusMessage.textContent = errorMessage;
        }
      }
    }
  });
}
